import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { translationHelper } from '~/helpers/translation.helper';

declare let $;

@Component({
    selector: 'oddView',
    templateUrl: './odd.view.html',
    styles: [
        `
        .goalscorer-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
            padding: 3px;
            width: 200%;
            margin-right: 4px;
        }

        .goalscorer-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 16px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 14px;
            cursor: pointer;
            transition: all 0.2s ease;
            border: 1px solid rgba(255, 255, 255, 0.2);
            height: 42px;
            overflow: hidden;
            height: 50px;
        }

        .goalscorer-item:hover {
            background: rgba(255, 255, 255, 0.15);
        }

        .goalscorer-item._selected {
            background: rgba(241, 199, 81);
            border-color: rgba(241, 199, 81);
        }

        .player-info {
            flex: 1;
            display: flex;
            align-items: center;
            margin-right: 16px;
            min-width: 0;
        }

        .player-name {
            font-size: 14px;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.9);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .goalscorer-item._selected .player-name {
            color: rgb(0, 0, 0);
        }

        .odd-value {
            font-size: 15px;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.9);
            min-width: 50px;
            text-align: right;
            padding: 6px 10px;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 14px;
            border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .goalscorer-item:hover .odd-value {
            background: rgba(255, 255, 255, 0.1);
            border-color: rgba(255, 255, 255, 0.2);
        }

        .goalscorer-item._selected .odd-value {
            color: rgb(0, 0, 0);
            background: rgb(242, 192, 55)
            border-color: rgb(0, 0, 0);
        }
    `,
    ],
})
export class OddView implements OnInit {
    @Input() oddNumber = 2;
    @Input() specialValShow = true;
    @Input() rowNumber = 1;
    @Input() typeOfList = 'pre';
    @Input() matchID: number;
    @Input() isWrapped = false;
    @Input() isDoubleWrap = false;
    @Input() isDoubleRow = false;
    @Input() isExpandView = false;
    @Input() isAppend = false;
    @Input() fixtureItem;
    @Input() hidingOfThird;
    @Input() hidingOfFirst;
    @Input() isEmptyType;
    @Input() isSecondHalf;

    useData = [];

    @Input() set _data(c) {
        if (c) {
            if (c.length > 0) {
                this.useData = c;

                // Special handling for Double Chance (OddTypeId 24)
                // This is a more robust check for Double Chance odds
                const isDoubleChance =
                    this.useData.length > 0 &&
                    ((this.useData[0] && this.useData[0].OddTypeId === 24) ||
                        (this.typeOfList === 'live' && this.rowNumber === 3)); // Third row in live view is usually Double Chance

                if (isDoubleChance) {
                    // Ensure we have the right order: 1X (80), 12 (81), X2 (82)
                    this.useData.sort((a, b) => {
                        if (!a || !b) return 0;

                        // Sort by ParameterOddId if available
                        if (a.ParameterOddId && b.ParameterOddId) {
                            return a.ParameterOddId - b.ParameterOddId;
                        }

                        // Fall back to OutCome if ParameterOddId not available
                        if (a.OutCome && b.OutCome) {
                            const outcomeOrder = { '1X': 0, '12': 1, X2: 2 };
                            return outcomeOrder[a.OutCome] - outcomeOrder[b.OutCome];
                        }

                        return 0;
                    });
                }

                if (this.useData.length < this.oddNumber) {
                    const count = this.oddNumber - this.useData.length;
                    for (let i = 0; i < count; i++) {
                        this.useData.push({
                            OddId: -1,
                            Visibility: 'hidden',
                            OddValue: '0',
                            BetStatus: 'none',
                        });
                    }
                }
            } else {
                this.useData = new Array(this.oddNumber);
            }
        } else {
            this.useData = new Array(this.oddNumber);
        }

        // console.log('--this.useData--',this.useData);
    }

    constructor(public tournamentsService: TournamentsService) {}

    ngOnInit() {
        // console.log('oddNumber',this.oddNumber);
        // console.log('specialValShow',this.specialValShow);
        // console.log('rowNumber',this.rowNumber);
        // console.log('typeOfList',this.typeOfList);
        // console.log('matchID',this.matchID);
        // console.log('isWrapped',this.isWrapped);
        // console.log('isDoubleWrap',this.isDoubleWrap);
        // console.log('isDoubleRow',this.isDoubleRow);
        // console.log('isExpandView',this.isExpandView);
        // console.log('isAppend',this.isAppend);
        // console.log('fixtureItem',this.fixtureItem);
        // console.log('hidingOfThird',this.hidingOfThird);
        // console.log('hidingOfFirst',this.hidingOfFirst);
        // console.log('isEmptyType',this.isEmptyType);
    }

    clickOddUP(odd, isClickable, isSlipAdd = false) {
        //console.log("Odd element : ", odd, this.fixtureItem);,
        const toogle = () => {
            let betType = '0';

            if (this.typeOfList === 'pre') {
                betType = '0';
            } else if (this.typeOfList === 'live') {
                betType = '1';
            }

            this.tournamentsService.addOddNew(
                odd,
                $('input[name="__RequestVerificationToken"]').val(),
                betType,
                this.fixtureItem,
            );
        };
        const clickValue = isSlipAdd ? 1 : -1;
        let slipLength = this.tournamentsService.slipCurrents.length + clickValue;
        if (slipLength === 1) {
            this.tournamentsService.BettingSlip_Menu_SlipType = 0;
        } else {
            this.tournamentsService.BettingSlip_Menu_SlipType = 1;
        }

        if (odd && isClickable) {
            toogle();
        } else {
            if (odd != undefined && this.checkSelected(odd.OddId) === '_selected') {
                toogle();
            }
        }
    }

    checkSelected(oddId) {
        return this.tournamentsService.slipCurrents.findIndex(v => v.OddId1 == oddId) > -1 ? '_selected' : '';
    }
}
